import service from '../service.js'

export default{

    listLeaveRecord(search){
        return service.get('leave_credit',{
            search : search
        })
    },
}